import React, { useState } from "react";
import Logo from "../../../assets/logo/logo2.png";

const TemplatePDFReportView = ({ data }) => {
  const [datauserpdf] = useState(data);

  const styles = {
    TittlePDF: {
      color: "#4dcaf3",
      padding: "10px 0px",
      fontsize: "1.6em",
      textalign: "left",
      textAlign: "initial",
      borderBottom: "2px solid",
    },
    boxinfotriPDF: {
      display: "flex",
      width: "100%",
      alignItems: "center",
      justifyContent: "space-around",
      flexWrap: "wrap",
      borderBottom: "0.5px dashed #d1d1d1",
      padding: "10px 0px",
    },
    boxinfotriPDFlast: {
      width: "100%",
      borderBottom: "0.5px dashed #d1d1d1",
      padding: "10px 0px",
    },
    divlabelspam: {
      color: "#224268",
      fontSize: "18px",
      fontWeight: "600",
      padding: "20px 0px",
      width: "33%",
      textAlign: "initial",
    },
    divlabelspamlast: {
      color: "#224268",
      fontSize: "18px",
      fontWeight: "600",
      padding: "20px 0px",
      width: "100%",
      textAlign: "initial",
    },
    divlabelspameconomic: {
      color: "#224268",
      fontSize: "18px",
      fontWeight: "600",
      padding: "10px 0px",
      width: "50%",
      textAlign: "initial",
    },
    pagefrompage: {
      margin: "30px 10px 0px 10px",
    },
    pagefrompagemax2: {
      margin: "60px 10px 0px 10px",
    },
    pagefrompageemployer: {
      margin: "50px 10px 0px 10px",
    },
    infopdf: {
      color: "#224268",
      fontSize: "18px",
      fontWeight: "500",
      margin: "0px 10px",
    },
    infopdflast: {
      color: "#224268",
      fontSize: "18px",
      fontWeight: "500",
      margin: "0px 10px",
      width: "100%",
    },
    tablebackground: {
      borderCollapse: "collapse",
      padding: "10px",
      border: "1px solid #ddd",
      width: "100%",
    },
    headertable: {
      color: "#737373",
      backgroundColor: "#f5f5f5",
      padding: "10px",
      border: "1px solid #ddd",
    },
    headerinfotableabm: {
      backgroundColor: "white",
      border: "1px solid #ddd",
      padding: "10px",
      color: "#737373",
    },

    boxnumbertablevarmatrx: {
      width: "25px",
      height: "25px",
    },

    headerinfotableabmnumber: {
      padding: "10px",
      fontSize: "16px",
      border: "1px solid #ddd",
    },

    header: {
      backgroundColor: "white",
      borderBotton: "1px solid #d1d1d1",
      boxShadow: "0px 10px 5px -3px rgba(0, 0, 0, 0.1)",
      padding: "10px",
      margin: "10px 0px",
      textAlign: "initial",
    },

    logo: {
      width: "200px",
      height: "100px",
    },

    footer: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      padding: "20px",
      margin: "30px 0px 0px 0px",
      borderTop: "1px solid #d1d1d1",
    },
    footertext: {
      fontSize: "12px",
      color: "#929292",
    },
    logofooter: {
      width: "100px",
      height: "50px",
    },
  };

  const riskColors = {
    1: "#5fbf49",
    2: "#f6e502",
    3: "#f49e01",
    4: "#ff7089",
    5: "red",
  };

  // Predefinir los valores para "Factor de riesgo" y "Variable"
  const combinedValues = data
    ? [
        {
          factorRiesgo: "Ingresos",
          variable: "Monto Transaccional Anual",
          valorObtenido: data.EconomicInformation.IncomeOfHumanPerson,
          riesgoObtenido: data.MDR.Income.value,
        },
        {
          factorRiesgo: "Ubicacion - Zona Geografica",
          variable: "Provincia",
          valorObtenido: data.province,
          riesgoObtenido: data.MDR.GeographicLocation.value,
        },
        {
          factorRiesgo: "Actividad que desarrolla",
          variable: "Actividades AFIP",
          valorObtenido: data.EmployerInformation.ActivityBeingCarriedOut,
          riesgoObtenido: data.MDR.ActivityBeingCarriedOut.value,
        },
        {
          factorRiesgo: "Antigüedad en la actividad",
          variable: "En REPSAL",
          valorObtenido: data.EmployerInformation.activitySeniority,
          riesgoObtenido: data.MDR.ActivitySeniority.value,
        },
        {
          factorRiesgo: "Tipo de operatoria",
          variable: "En REPSAL",
          valorObtenido: data.RelationshipWithMutual.typeOfCredit,
          riesgoObtenido: data.MDR.TypeOperation.value,
        },
        {
          factorRiesgo: "Tipo de cliente",
          variable: "Persona Humana o Jurídica",
          valorObtenido: data.typeCustomer,
          riesgoObtenido: data.MDR.TypeCustomer.value,
        },
        {
          factorRiesgo: "Presentación de documentación",
          variable: "Documentación",
          valorObtenido: data.MDR.Documentation.data,
          riesgoObtenido: data.MDR.Documentation.value,
        },
        {
          factorRiesgo: "Canal",
          variable: "Físico o Digital",
          valorObtenido: data.MDR.Canal.data,
          riesgoObtenido: data.MDR.Canal.value,
        },
      ]
    : [];

  const typeRelationMutual = () => {
    if (datauserpdf.RelationshipWithMutual.relation === "Socio") {
      return (
        <div style={styles.pagefrompage}>
          <div>
            <h2 style={styles.TittlePDF}>Relación con la mutual</h2>
          </div>
          <div>
            <div style={styles.boxinfotriPDF}>
              <div style={styles.divlabelspameconomic}>
                <label>Relación:</label>
                <span style={styles.infopdf}>
                  {datauserpdf.RelationshipWithMutual.relation}
                </span>
              </div>
              <div style={styles.divlabelspameconomic}>
                <label>Fecha de crédito:</label>
                <span style={styles.infopdf}>
                  {datauserpdf.RelationshipWithMutual.creditDate}
                </span>
              </div>
            </div>
            <div style={styles.boxinfotriPDF}>
              <div style={styles.divlabelspameconomic}>
                <label>Tipo de crédito:</label>
                <span style={styles.infopdf}>
                  {datauserpdf.RelationshipWithMutual.typeOfCredit}
                </span>
              </div>
              <div style={styles.divlabelspameconomic}>
                <label>Monto de crédito:</label>
                <span style={styles.infopdf}>
                  {datauserpdf.RelationshipWithMutual.amountOfCredit}
                </span>
              </div>
            </div>
            <div style={styles.boxinfotriPDF}>
              <div style={styles.divlabelspameconomic}>
                <label>Cantidad de cuotas:</label>
                <span style={styles.infopdf}>
                  {datauserpdf.RelationshipWithMutual.amountOfFees}
                </span>
              </div>
              <div style={styles.divlabelspameconomic}>
                <label>Monto de la cuota:</label>
                <span style={styles.infopdf}>
                  {datauserpdf.RelationshipWithMutual.installmentAmount}
                </span>
              </div>
            </div>
            <div style={styles.boxinfotriPDF}>
              <div style={styles.divlabelspameconomic}>
                <label>Entidad de Prestamo:</label>
                <span style={styles.infopdf}>
                  {datauserpdf.RelationshipWithMutual.loanBank}
                </span>
              </div>
              <div style={styles.divlabelspameconomic}>
                <label>Afiliado:</label>
                <span style={styles.infopdf}>
                  {datauserpdf.RelationshipWithMutual.affiliate}
                </span>
              </div>
            </div>
            <div style={styles.boxinfotriPDF}>
              <div style={styles.divlabelspameconomic}>
                <label>Crédito:</label>
                <span style={styles.infopdf}>
                  {datauserpdf.RelationshipWithMutual.credit}
                </span>
              </div>
              <div style={styles.divlabelspameconomic}>
                <label>Canal:</label>
                <span style={styles.infopdf}>
                  {datauserpdf.RelationshipWithMutual.canal}
                </span>
              </div>
            </div>
          </div>
        </div>
      );
    } else if (datauserpdf.RelationshipWithMutual.relation === "Proveedor") {
      return (
        <div style={styles.pagefrompage}>
          <div>
            <h2 style={styles.TittlePDF}>Relación con la mutual</h2>
          </div>
          <div>
            <div style={styles.boxinfotriPDF}>
              <div style={styles.divlabelspameconomic}>
                <label>Relación:</label>
                <span style={styles.infopdf}>
                  {datauserpdf.RelationshipWithMutual.relation}
                </span>
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div style={styles.pagefrompage}>
          <div>
            <h2 style={styles.TittlePDF}>Relación con la mutual</h2>
          </div>
          <div>
            <div style={styles.boxinfotriPDF}>
              <div style={styles.divlabelspameconomic}>
                <label>Relación:</label>
                <span style={styles.infopdf}>
                  {datauserpdf.RelationshipWithMutual.relation}
                </span>
              </div>
            </div>
          </div>
        </div>
      );
    }
  };

  return (
    <div>
      <div style={styles.header}>
        <img src={Logo} style={styles.logo} alt="Logo" />
      </div>
      <div style={styles.pagefrompagemax2}>
        <div>
          <h2 style={styles.TittlePDF}>Información Personal</h2>
        </div>
        <div style={styles.boxinfotriPDF}>
          <div style={styles.divlabelspam}>
            <label>Nombre:</label>
            <span style={styles.infopdf}>{datauserpdf.name}</span>
          </div>
          <div style={styles.divlabelspam}>
            <label>Apellido:</label>
            <span style={styles.infopdf}>{datauserpdf.lastName}</span>
          </div>
          <div style={styles.divlabelspam}>
            <label>Tipo de documento:</label>
            <span style={styles.infopdf}>{datauserpdf.documentType}</span>
          </div>
        </div>
        <div style={styles.boxinfotriPDF}>
          <div style={styles.divlabelspam}>
            <label>DNI:</label>
            <span style={styles.infopdf}>{datauserpdf.dni}</span>
          </div>
          <div style={styles.divlabelspam}>
            <label>Nacionalidad:</label>
            <span style={styles.infopdf}>{datauserpdf.nacionality}</span>
          </div>
          <div style={styles.divlabelspam}>
            <label>Estado Civil:</label>
            <span style={styles.infopdf}>{datauserpdf.civilStatus}</span>
          </div>
        </div>
        <div style={styles.boxinfotriPDF}>
          <div style={styles.divlabelspam}>
            <label>Cuil:</label>
            <span style={styles.infopdf}>{datauserpdf.cuil}</span>
          </div>
          <div style={styles.divlabelspam}>
            <label>Fecha de nacimiento:</label>
            <span style={styles.infopdf}>{datauserpdf.dateOfBirth}</span>
          </div>
          <div style={styles.divlabelspam}>
            <label>Lugar de nacimiento:</label>
            <span style={styles.infopdf}>{datauserpdf.placeOfBirth}</span>
          </div>
        </div>
        <div style={styles.boxinfotriPDF}>
          <div style={styles.divlabelspam}>
            <label>Telefono:</label>
            <span style={styles.infopdf}>{datauserpdf.phone}</span>
          </div>
          <div style={styles.divlabelspam}>
            <label>Correo electronico:</label>
            <span style={styles.infopdf}>{datauserpdf.email}</span>
          </div>
          <div style={styles.divlabelspam}>
            <label>Nivel Socio Económico:</label>
            <span style={styles.infopdf}>{datauserpdf.SocioEconomicLevel}</span>
          </div>
        </div>
        <div style={styles.boxinfotriPDF}>
          <div style={styles.divlabelspam}>
            <label>Calle:</label>
            <span style={styles.infopdf}>{datauserpdf.street}</span>
          </div>
          <div style={styles.divlabelspam}>
            <label>Numero:</label>
            <span style={styles.infopdf}>{datauserpdf.numberStreet}</span>
          </div>
          <div style={styles.divlabelspam}>
            <label>Codigo Postal:</label>
            <span style={styles.infopdf}>{datauserpdf.postalCode}</span>
          </div>
        </div>
        <div style={styles.boxinfotriPDF}>
          <div style={styles.divlabelspam}>
            <label>Departamento:</label>
            <span style={styles.infopdf}>{datauserpdf.apartment}</span>
          </div>
          <div style={styles.divlabelspam}>
            <label>Piso:</label>
            <span style={styles.infopdf}>{datauserpdf.floor}</span>
          </div>
          <div style={styles.divlabelspam}>
            <label>Localidad:</label>
            <span style={styles.infopdf}>{datauserpdf.location}</span>
          </div>
        </div>
        <div style={styles.boxinfotriPDFlast}>
          <div style={styles.divlabelspam}>
            <label>Provincia:</label>
            <span style={styles.infopdf}>{datauserpdf.province}</span>
          </div>
        </div>
      </div>
      <div style={styles.pagefrompagemax2}>
        <div>
          <h2 style={styles.TittlePDF}>Información Economica</h2>
        </div>
        <div style={styles.boxinfotriPDF}>
          <div style={styles.divlabelspameconomic}>
            <label>Monto Transaccional Anual:</label>
            <span style={styles.infopdf}>
              {datauserpdf.EconomicInformation.IncomeOfHumanPerson}
            </span>
          </div>
          <div style={styles.divlabelspameconomic}>
            <label>Total de endeudamiento del sistema financiero:</label>
            <span style={styles.infopdf}>
              {
                datauserpdf.EconomicInformation
                  .total_indebtedness_of_the_financial_system
              }
            </span>
          </div>
        </div>
        <div style={styles.boxinfotriPDF}>
          <div style={styles.divlabelspameconomic}>
            <label>Total de compromiso mensual sistema financiero:</label>
            <span style={styles.infopdf}>
              {
                datauserpdf.EconomicInformation
                  .total_monthly_commitment_of_the_financial_system
              }
            </span>
          </div>
          <div style={styles.divlabelspameconomic}>
            <label>Situación vigente ante BCRA:</label>
            <span style={styles.infopdf}>
              {datauserpdf.EconomicInformation.current_status_with_BCRA}
            </span>
          </div>
        </div>
      </div>
      <div style={styles.pagefrompageemployer}>
        <div>
          <h2 style={styles.TittlePDF}>Información Empleador</h2>
        </div>
        <div style={styles.boxinfotriPDF}>
          <div style={styles.divlabelspameconomic}>
            <label>Empleador:</label>
            <span style={styles.infopdf}>
              {datauserpdf.EmployerInformation.employer}
            </span>
          </div>
          <div style={styles.divlabelspameconomic}>
            <label>Actividad que desarrolla:</label>
            <span style={styles.infopdf}>
              {datauserpdf.EmployerInformation.ActivityBeingCarriedOut}
            </span>
          </div>
        </div>
        <div style={styles.boxinfotriPDF}>
          <div style={styles.divlabelspameconomic}>
            <label>Domicilio Empleador:</label>
            <span style={styles.infopdf}>
              {datauserpdf.EmployerInformation.employerDomicile}
            </span>
          </div>
          <div style={styles.divlabelspameconomic}>
            <label>Actividad laboral:</label>
            <span style={styles.infopdf}>
              {datauserpdf.EmployerInformation.WorkActivity}
            </span>
          </div>
        </div>
        <div style={styles.boxinfotriPDFlast}>
          <div style={styles.divlabelspam}>
            <label>Antigüedad en la actividad:</label>
            <span style={styles.infopdf}>
              {datauserpdf.EmployerInformation.activitySeniority}
            </span>
          </div>
        </div>
      </div>
      {typeRelationMutual()}
      <div style={styles.pagefrompage}>
        <div>
          <h2 style={styles.TittlePDF}>Informacion PEP</h2>
        </div>
        <div style={styles.boxinfotriPDFlast}>
          <div style={styles.divlabelspam}>
            <label>Es políticamente expuesto:</label>
            <span style={styles.infopdf}>
              {datauserpdf.PoliticalInformation.politicallyExposed}
            </span>
          </div>
        </div>
      </div>
      <div style={styles.pagefrompage}>
        <div>
          <h2 style={styles.TittlePDF}>Información Terrorismo</h2>
        </div>
        <div style={styles.boxinfotriPDFlast}>
          <div style={styles.divlabelspamlast}>
            <label>Verificación de terrorismo (DNI):</label>
            <span style={styles.infopdf}>
              {datauserpdf.PoliticalInformation.terrorismVerification}
            </span>
          </div>
        </div>
        <div style={styles.boxinfotriPDFlast}>
          <div style={styles.divlabelspamlast}>
            <label>Resultado:</label>
            <span style={styles.infopdflast}>
              {datauserpdf.PoliticalInformation.verification}
            </span>
          </div>
        </div>
      </div>
      <div style={styles.pagefrompage}>
        <div>
          <h2 style={styles.TittlePDF}>ABM de documentos</h2>
        </div>
        {!datauserpdf.ABMOfDocument ? (
          <p>No hay ABM's cargados.</p>
        ) : (
          <div>
            <table style={styles.tablebackground}>
              <thead>
                <tr>
                  <th style={styles.headertable}>Tipo de archivo</th>
                  <th style={styles.headertable}>Descripcion</th>
                  <th style={styles.headertable}>Fecha de creación</th>
                </tr>
              </thead>
              <tbody>
                {datauserpdf.ABMOfDocument.map((item, index) => (
                  <tr key={index}>
                    <td style={styles.headerinfotableabm}>
                      {item.typeDocument}
                    </td>
                    <td style={styles.headerinfotableabm}>
                      {item.description}
                    </td>
                    <td style={styles.headerinfotableabm}>{item.createAt}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
      <div style={styles.pagefrompage}>
        <div>
          <h2 style={styles.TittlePDF}>Matriz de Variables</h2>
        </div>
        <table style={styles.tablebackground}>
          <thead>
            <tr>
              <th style={styles.headertable}>Factor de riesgo</th>
              <th style={styles.headertable}>Variable</th>
              <th style={styles.headertable}>Valor obtenido</th>
              <th style={styles.headertable}>Riesgo obtenido</th>
            </tr>
          </thead>
          <tbody>
            {combinedValues.map((item, index) => (
              <tr key={index}>
                <td style={styles.headerinfotableabm}>{item.factorRiesgo}</td>
                <td style={styles.headerinfotableabm}>{item.variable}</td>
                <td style={styles.headerinfotableabm}>{item.valorObtenido}</td>
                <td style={styles.headerinfotableabmnumber}>
                  <div
                    style={{
                      width: "25px",
                      height: "25px",
                      margin: "auto",
                      color: "white",
                      fontWeight: "600",
                      backgroundColor: riskColors[item.riesgoObtenido],
                    }}
                  >
                    <p style={{ padding: "4px 0px 0px 7px", margin: "auto" }}>
                      {item.riesgoObtenido}
                    </p>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div style={styles.footer}>
        <div>
          <p style={styles.footertext}>
            © 2024. Todos los derechos reservados.
          </p>
        </div>
        <div>
          <img style={styles.logofooter} src={Logo} alt="Logo" />
        </div>
      </div>
    </div>
  );
};

export default TemplatePDFReportView;
